import { render } from "./timeConfig.vue?vue&type=template&id=65039398"
import script from "./timeConfig.vue?vue&type=script&lang=js"
export * from "./timeConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__